/**
 * Change the tag of an element.
 *
 * @param {element} element The element to change.
 * @param {string}  newTag  The new tag to use.
 * @return {*} The new element.
 */
export const changeElementTag = ( element, newTag ) => {
	const newElement = document.createElement( newTag );
	newElement.innerHTML = element.innerHTML;
	element.parentNode.replaceChild( newElement, element );
	return newElement;
};

/**
 * Is an element visible  el.checkVisibility() is not available in Safari yet.
 *
 * @param {HTMLElement} element The element to check.
 * @return {boolean} If element is visible or not.
 */
export const isVisible = ( element ) => {
	if ( typeof element.checkVisibility === 'function' ) {
		return element.checkVisibility();
	}
	return element.offsetWidth > 0 || element.offsetHeight > 0;
};
